import React from "react";
import PropTypes from "prop-types";
import { connectSearchBox } from "react-instantsearch-dom";

import AlgoliaConfigure from "components/AlgoliaConfigure";
import { ALGOLIA_FILTERS, TEMPLATE_GROUP_TYPE_NAMES } from "enums";
import PersonPresenter from "presenters/PersonPresenter";

import SearchResults from "../SearchResults";

const AlgoliaSearchBox = ({ person, dateType, dateToCelebrate, onClose }) => {
  const noGifs = `NOT ${ALGOLIA_FILTERS.templateGroupTypeName}:"${TEMPLATE_GROUP_TYPE_NAMES.starringYouGif}"`;
  const noSUs = `NOT ${ALGOLIA_FILTERS.templateGroupTypeName}:"${TEMPLATE_GROUP_TYPE_NAMES.straightUpEcard}"`;
  const noMorphables = `NOT ${ALGOLIA_FILTERS.templateGroupTypeName}:"${TEMPLATE_GROUP_TYPE_NAMES.starringYouAI}"`;
  const castOne = `${ALGOLIA_FILTERS.castNumOptions} = 1`;
  const filters = `${noGifs} AND ${noSUs} AND ${noMorphables} AND ${castOne}`;

  return (
    <div>
      <AlgoliaConfigure filters={filters} />
      <SearchResults person={person} dateType={dateType} dateToCelebrate={dateToCelebrate} onClose={onClose} />
    </div>
  );
};

AlgoliaSearchBox.propTypes = {
  person: PersonPresenter.shape().isRequired,
  dateType: PropTypes.string.isRequired,
  dateToCelebrate: PropTypes.string,
  onClose: PropTypes.func,
};

const SearchBox = connectSearchBox(AlgoliaSearchBox);

export default SearchBox;
